<div>
  <p-table [value]="events" styleClass="text-xs" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>Nome</th>
        <th>Categoria</th>
        @if (!hideStatus) {
          <th>Estado</th>
        }
        <th>Data de Ocorrência</th>
        @if (!hideTerminationDate) {
          <th>Data para Remoção</th>
        }
        <th>Província</th>
        <th>Açcões</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-event>

      <tr>
        <td>{{ event.title }}</td>
        <td>{{ event.category.description | titlecase }}</td>
        @if (!hideStatus) {
          <td>{{ event.status.description | titlecase }}</td>
        }
        <td>{{ event.eventDate | date:'yyyy-MM-dd' }}</td>
        @if (!hideTerminationDate) {
          <td>{{ event.terminationDate | date:'yyyy-MM-dd' }}</td>
        }

        <td>{{ event.province.description }}</td>
        <td><i (click)="selectObjectForDropDown(event) ; setMouseEvent($event)" class="btn pi pi-cog cursor-pointer"></i></td>
      </tr>
    </ng-template>
  </p-table>

  @if (!hasEvents) {
    <p class="flex justify-center text-sm text-gray-500 font-medium my-10">Nenhuma ocorrência foi
    encontrada, por favor verifique os filtros</p>
  }
</div>

<app-event-drop-down-menu
  (onRestoreToRemoveSuccess)="onEventRestoreToRemove($event)"
  (onEditSuccess)="onEditEvent($event)"
  (onCloseEventSuccess)="removeEventFromList($event)"
  (onEventTreatmentSuccess)="removeEventFromList($event)"
[event]="selectedEvent" [isAdmin]="true" [clickEvent]="mouseEvent"></app-event-drop-down-menu>
